<template>
  <div class="index">
    <div class="main">
      <img class="giftLogo" src="../assets/img/pic/phone/logo.png" alt />
      <!-- 选择store -->
      <div class="storeid" align="center">
        <label class="div_sel" @click="show_options" for="storeId">
          <label
            style="color: #b5b5b5;display:block;width: calc(100% - 25px);float: left;text-align: center;overflow: hidden;font-family: Poppins-Regular;font-size:12px;letter-spacing: 1px;"
            id="show_text">Please Select Store ID</label>
          <label style="display:block;width: 25px;float: left" id="down_icon">
            <img style="width:12px;height:6px;margin-right: 5px;" class="selIcon" src="../assets/img/xiajian.png" alt />
          </label>
        </label>
        <div id="_option" class="_option">
          <div class="options" @click="selStoreId($event)" value="0">Please Select Store ID</div>
          <div class="options" @click="selStoreId($event)" v-for="option in options" v-bind:value="option.store_id ">
            {{ option.sales_name }} - {{ option.store_id }}</div>
        </div>
        <div id="storeIdDiv" class="store_id_div"></div>
      </div>
      <!-- 右上角user -->
      <div class="account">
        <div @click="clickDropDown" class="user">
          <img src="../assets/img/pic/phone/user.png" alt />
          <!-- <img class="jiantou" v-if="arrow" src="../assets/img/youjian1.png" alt />
          <img class="jiantou1" v-else src="../assets/img/xiajian.png" alt /> -->
        </div>
        <div v-if="userCenter" class="logout">
          <p @click="loactionHerf">
            <img src="../assets/img/set1.png" alt />User Center
          </p>
          <p class="Logout-pc" @click="clickLogoutPc">
            <img src="../assets/img/close1.png" alt />Logout
          </p>
          <p class="Logout-phone" @click="clickLogoutPh">
            <img src="../assets/img/close1.png" alt />Logout
          </p>
        </div>
      </div>
      <div class="bottom">
        <div class="modular">
          <!-- <div class="modular-left">
            <div>
              <img src="../assets/img/saoma.png" alt />
            </div>
            <p>Redeem</p>
          </div> -->
          <div class="modular-right">
            <div @click="startScan('Redeem')">
              <img src="../assets/img/saoma.png" alt />
            </div>
            <p style="font-size:.8rem;font-family: 'Poppins-Regular';">Redeem</p>
          </div>
        </div>
        <div class="function">
          <div @click="startScan('Check')" class="check">
            <img src="../assets/img/pic/phone/check-circle.png" alt />
            <p style="font-size:.8rem;margin-bottom: 16px;font-family: 'Poppins-Regular';">Check</p>
          </div>
          <div @click="clickGoHistory" class="history">
            <img src="../assets/img/pic/phone/历史.png" alt />
            <p style="font-size:.8rem;margin-bottom: 16px;font-family: 'Poppins-Regular';">History</p>
          </div>
        </div>
      </div>

      <!-- pc 弹窗 -->
      <div class="pc-content">
        <!-- 主页 -->
        <div v-if="pcScanIndex" class="pc-scan">
          <div class="pc-modulart">
            <div @click="clickScanCode('Redeem')">
              <img src="../assets/img/saoma.png" alt />
            </div>
            <p>Redeem</p>
          </div>
          <div class="pc-fun">
            <div @click="clickScanCode('Check')" class="pc-check">
              <img src="../assets/img/index (1).png" alt />
              <span>Check</span>
            </div>
            <div @click="clickGoHistory" class="pc-history">
              <img src="../assets/img/history.png" alt />
              <span>History</span>
            </div>
          </div>
        </div>
        <div v-if="pcPopup" class="public">
          <div class="pc-box">
            <!-- 扫码弹窗 -->
            <div v-if="pxScanCode" class="pc-scan-code">
              <div @click="clickClosePcScan" class="pc-scan-code-img">
                <img src="../assets/img/pcguanbi.png" alt="" />
              </div>
              <img src="../assets/img/pc-scan.png" alt />
              <p>Pls scan the code</p>
              <div class="or">
                <div class="or-left"></div>
                <span>or</span>
                <div class="or-right"></div>
              </div>
              <div class="pc-man">
                <input id="pc-content" @change="inputNum" v-focus="true" v-model="sn" type="text"
                  placeholder="Manual Input" />
                <button @click="MannulInputSubmit">Submit</button>
              </div>
            </div>
 b
            <!-- loading 弹窗 -->
            <div v-if="loading" class="loading">
              <img src="../assets/img/loading.png" alt />
              <p class="loading-wait">Processing...({{ countDown }}s)</p>
              <button @click="clickClose('loading')">Close</button>
            </div>

            <!-- overtime 弹窗 -->
            <div v-if="overtime" class="overtime">
              <img src="../assets/img/gantan.png" alt />
              <p class="p1">
                {{ overtimeTips }}
              </p>
              <p class="p2">
                Click
                <span class="here" @click="clickRetry('pc')">here</span> to
                Retry
              </p>
              <button @click="clickClose('overtime')">Close</button>
            </div>

            <!-- success 弹窗 -->
            <div v-if="success" class="success">
              <img src="../assets/img/success.png" alt />
              <p>{{ successfulTips }}</p>
              <button @click="clickClose('success')">Close</button>
            </div>

            <!-- fail 弹窗 -->
            <div v-if="fail" class="fail">
              <img src="../assets/img/fail.png" alt />
              <p>{{ FailMsg }}</p>
              <button @click="clickClose('fail')">Close</button>
            </div>
          </div>
        </div>
      </div>

      <!-- pc 退出登录的弹窗 -->
      <div v-if="clickPcEnter" class="pc-enter">
        <div class="pc-confirm">
          <div class="confirm-img">
            <img src="../assets/img/pc.png" alt="" />
          </div>
          <p class="pc-lo-out">Confirm Log Out?</p>
          <div class="pc-enterbox">
            <button @click="clickLogoutPcOut('Confirm')" class="pcenter-confirm">
              Confirm
            </button>
            <button @click="clickLogoutPcOut('Cancel')" class="pcenter-cancel">
              Cancel
            </button>
          </div>
        </div>
      </div>

      <!-- phone 弹窗 -->
      <div v-if="phoneContent" class="phone-content">
        <div class="phone-public">
          <!-- loading -->
          <div v-if="phoneLoading" class="phone-loading">
            <img src="../assets/img/loading.png" alt />
            <p>Processing...({{ phonecountDown }}s)</p>
          </div>

          <!-- overtime -->
          <div v-if="phoneOvertime" class="phone-overtime">
            <img src="../assets/img/ph-overtime.png" alt />
            <p class="ph-p1">
              {{ overtimeTips }}
            </p>
            <p class="ph-p2">
              Click
              <span class="here" @click="clickRetry('phone')">here</span> to
              Retry
            </p>
          </div>

          <!-- success -->
          <div v-if="phoneSuccess" class="phone-success">
            <img src="../assets/img/ph-success.png" alt />
            <p style="">{{ successfulTips }}</p>
          </div>

          <!-- fail -->
          <div v-show="phoneFail" class="phone-fail">
            <img src="../assets/img/ph-fail.png" alt />
            <p class="phone-fail-p1">
              {{ PhFailMsg }}
            </p>
            <!-- <p class="phone-fail-p2">redeemed(ErrCode:4202)</p> -->
          </div>
        </div>
        <img @click="clickClosephoneFail" class="phone-close" src="../assets/img/ph-close.png" alt />
      </div>

      <!-- phone 手动输入的弹窗 -->
      <div v-if="phoneEnter" class="please-enter">
        <div class="enter-content">
          <div class="enter-img">
            <img src="../assets/img/juan.png" alt="" />
          </div>
          <input v-focus="true" class="enter-input" v-model="phoneManInputEnter" type="text"
            placeholder="Please enter coupon manually" />
          <div class="enter-box">
            <button @click="clickEnter('Confirm')" class="enter-confirm">
              Confirm
            </button>
            <button @click="clickEnter('Cancel')" class="enter-cancel">
              Cancel
            </button>
          </div>
        </div>
      </div>

      <!-- phone 退出登录的弹窗 -->
      <div v-if="phoneLogOut" class="please-enter">
        <div class="enter-content">
          <div class="enter-img ph-enter-img">
            <img src="../assets/img/zhuxiao.png" alt="" />
          </div>
          <p class="enter-LoOut">Confirm Log Out?</p>
          <div class="enter-box">
            <button @click="clickLogoutPhone('Confirm')" class="enter-confirm">
              Confirm
            </button>
            <button @click="clickLogoutPhone('Cancel')" class="enter-cancel">
              Cancel
            </button>
          </div>
        </div>
      </div>

    </div>

    <div>
      <audio src="../assets/saoyisao.mp3" ref="audio"></audio>
      <div class="container">
        <!-- <i class="mintui mintui-saoyisao" @click="startScan"></i> -->
        <!-- <field label placeholder v-model="decodedString" type="textarea" disabled></field> -->
        <!-- <Button
          type="danger"
          size="large"
          @click="openInBrowser(decodedString)"
          v-show="isUrl"
          class="openBtn"
        >Open</Button>-->
      </div>
      <popup v-model="showScan" :pop-transition="'popup-fade'" class="scanWrapper">
        <qrcode-stream @decode="onDecode" :camera="camera" @init="onInit" v-if="!destroyed" :track="false"
          :torch="torch">
          <div class="loading-indicator" v-if="loading">
            <div class="spinner spinner__1"></div>
          </div>
        </qrcode-stream>
        <div class="header">
          <i class="mint-toast-icon mintui mintui-back" @click="stopScan"></i>
          <div class="title">Scan Coupon</div>
        </div>
        <div class="scanBox">
          <div class="lineScanner" ref="line"></div>
        </div>
        <div class="footer">
          <!-- <i class="mintui mintui-xiangjiqiehuan" @click="switchCamera"></i>
          <i
            class="mintui"
            :class="{'mintui-saoyisao-shoudiantong-guan': !torch,'mintui-saoyisao-shoudiantong-kai': torch,'torch-disabled': !isSupportTorch}"
            @click="toggleTorch"
          ></i>
          <i class="mintui mintui-xiangji" @click="takePhoto"></i>-->
          <button @click="PhoneManInput" class="Mannul">Enter Coupon</button>
        </div>
        <qrcode-capture @decode="onCaptureDecode" :multiple="false" ref="photo" />
      </popup>
    </div>
  </div>
</template>

<script>
  import {
    Popup,
    Field,
    Toast,
    Button,
    InfiniteScroll,
    MessageBox,
  } from "mint-ui";
  import {
    QrcodeStream,
    QrcodeCapture
  } from "vue-qrcode-reader";
  import $ from "jquery";
  import isURL from "is-url";
  import {
    UseVoucher,
    Query,
    getStoreIds,
    CheckRedeemType
  } from "@/api/account";
  import local from "@/utils/local";
  export default {
    components: {
      Popup,
      QrcodeStream,
      Field,
      QrcodeCapture,
      Button,
    },
    directives: {
      focus: {
        inserted: function (el, {
          value
        }) {
          if (value) {
            el.focus();
          }
        },
      },
    },

    data() {
      return {
        optionStatus: null,
        isSupportTorch: false,
        torch: false,
        camera: "rear",
        showScan: false,
        decodedString: "",
        errorMsg: "",
        loading: false,
        destroyed: true,
        noFrontCamera: false,
        noRearCamera: false,

        countDown: 30,
        phonecountDown: 30,
        arr: [],

        arrow: true,
        userCenter: false,
        pcScanIndex: true, //首页
        pxScanCode: false, //扫码弹窗
        pcPopup: false, //弹窗模型
        loading: false, //loading弹窗
        overtime: false, //超时弹窗
        success: false, //成功弹窗
        fail: false, //失败弹窗
        clickPcEnter: false,
        phoneContent: false,
        phoneLoading: false,
        phoneOvertime: false,
        phoneSuccess: false,
        phoneFail: false,
        phoneEnter: false,
        phoneLogOut: false,
        phoneManInputEnter: "",
        keyDownTime: "",
        keyUpTime: "",
        title: "",

        FailMsg: "",
        PhFailMsg: "Fail! Fail! Fail!",
        successfulTips: "The balance is 23.12 and expire on 20/12/2021",
        overtimeTips: "",

        sn: "",
        user_tag: "",
        options: [],
        storeId: '',
      }
    },

    methods: {
      async onInit(promise) {
        console.log("启动");
        // show loading indicator
        this.isSupportTorch = true;
        this.loading = true;
        this.$refs.line.style.display = "none";
        try {
          const {
            capabilities
          } = await promise;

          this.isSupportTorch = !!capabilities.torch;
          // successfully initialized
        } catch (error) {
          if (error.name === "NotAllowedError") {
            // user denied camera access permisson
            this.errorMsg = "ERROR: you need to grant camera access permisson";
          } else if (error.name === "NotFoundError") {
            // no suitable camera device installed
            this.errorMsg = "ERROR: no camera on this device";
          } else if (error.name === "NotSupportedError") {
            // page is not served over HTTPS (or localhost)
            this.errorMsg = "ERROR: secure context required (HTTPS, localhost)";
          } else if (error.name === "NotReadableError") {
            // maybe camera is already in use
            this.errorMsg = "ERROR: is the camera already in use?";
          } else if (error.name === "OverconstrainedError") {
            // did you requested the front camera although there is none?
            this.errorMsg = "ERROR: installed cameras are not suitable";
          } else if (error.name === "StreamApiNotSupportedError") {
            // browser seems to be lacking features
            this.errorMsg =
              "ERROR:  Scanning QR codes is not supported in this browser";
          }
          const cameraMissingError = error.name === "OverconstrainedError";
          const triedRearCamera = this.camera === "rear";
          const triedFrontCamera = this.camera === "front";

          if (triedRearCamera && cameraMissingError) {
            //没有后置摄像头
            this.errorMsg = "You don't seem to have a rear camera on your device";
            this.noRearCamera = true;
          }

          if (triedFrontCamera && cameraMissingError) {
            this.errorMsg =
              "You don't seem to have a front camera on your device";
            this.noFrontCamera = true;
          }
        } finally {
          this.loading = false;
          if (this.errorMsg) {
            Toast(this.errorMsg);
            this.stopScan();
          } else if (this.errorMsg && (this.noRearCamera || this.noFrontCamera)) {
            Toast(this.errorMsg);
          } else {
            this.$refs.line.style.display = "block";
          }
          // hide loading indicator
        }
      },
      async getOptions() {
        let {
          code,
          msg,
          data
        } = await getStoreIds();

        if (code == "1") {
          // 判断长度
          if (data.list.length > 1) {
            $("#storeIdDiv").hide();
            this.options = data.list;
            this.optionStatus = 1;
          } else {
            if (data.list.length == 1) {
              var item = [];
              for (var i in data.list) {
                item = data.list[i];
              }
              this.storeId = item.store_id;
              this.optionStatus = 0;

              $("#storeId").hide();
              $(".div_sel").hide();
              $("#storeIdDiv").show();
              $("#storeIdDiv").html(item.sales_name + " - " + item.store_id);
            } else {
              this.optionStatus = 0;
              $("#storeId").hide();
              $(".div_sel").hide();
              $("#storeIdDiv").hide();
            }
          }
        } else {
          this.options = [];
        }
      },
      selStoreId(event) {
        var that = event.currentTarget;

        var store_id = $(that).attr("value");
        // console.log(store_id);
        // 样式
        for (let i = 0; i < $(".options").length; i++) {
          $(".options").css({
            "background": "unset"
          })
        }
        $(that).css({
          "background": "rgba(255, 255, 255, .4)"
        })
        // 判断是否为上次选择的，是则取消
        if (store_id == this.storeId) {
          console.log("取消");
          $(that).css({
            "background": "unset"
          })
          this.storeId="";
          $("#show_text").html("");
          $("#_option").hide();
          return false;
        }
        this.storeId = store_id;
        console.log(this.storeId);

        // 扫码前校验
        if (this.storeId != 0) {
          this.optionStatus = 0
          $("#show_text").css("color", "#fff");

        } else {
          this.optionStatus = 1
          $("#show_text").css("color", "#b5b5b5");
        }

        $("#show_text").html($(that).html());
        $("#_option").hide();
      },
      show_options() {
        //$("#storeId").trigger("change");
        var x = $(".div_sel").offset().top + 56;
        var y = $(".div_sel").offset().left;
        var _width = $(".div_sel").width();

        $("#_option").css({
          "width": _width,
          "top": x,
          "left": y
        });

        $("#_option").toggle();
      },
      switchCamera() {
        console.log(this.camera);
        switch (this.camera) {
          case "front":
            this.camera = "rear";
            break;
          case "rear":
            this.camera = "front";
            break;
        }
      },
      toggleTorch() {
        if (this.isSupportTorch) this.torch = !this.torch;
      },
      takePhoto() {
        //解析二维码的过程中 不能再点击拍照
        if (!this.loading) {
          this.$refs.photo.$el.dispatchEvent(new MouseEvent("click"));
        }
      },

      // 点击核销劵码或查询
      startScan(name) {
        // console.log("扫码！");
        this.showScan = true;
        this.destroyed = false;
        this.camera = "rear";

        var num = Math.ceil(Math.random() * 100000000).toString();
        var time = new Date().getTime().toString();
        this.user_tag = num + time;

        if (name === "Redeem") {
          this.title = "Redeem";
        } else if (name === "Check") {
          this.title = "Check";
        }
        
      },

      stopScan() {
        this.isSupportTorch = true; //纯粹为了隐藏手电筒图标,不为什么
        this.destroyed = true;
        this.$refs.line.style.display = "none";
        this.showScan = false;
      },
      onDecode(decodedString) {
        this.handleDecodeString(decodedString);
      },
      onCaptureDecode(decodedString) {
        this.handleDecodeString(decodedString);
      },
      // timeout(ms) {
      //   return new Promise((resolve) => {
      //     window.setTimeout(resolve, ms);
      //   });
      // },
      async handleDecodeString(decodedString) {
        this.$refs.audio.play();
        this.phoneFetchData();
        this.$refs.line.style.display = "none";
        // await this.timeout(3000);
        this.decodedString = decodedString;
        this.stopScan();
        this.phoneContent = true;
        this.phoneLoading = true;

        if (this.title == "Redeem") {
          console.log(this.decodedString);
          var snType = this.decodedString.substr(0, 6);
          if (snType != 'NEGIFT' && (this.storeId == 0 || this.storeId == '')) {
            this.phoneLoading = false;
            this.phoneContent = false;
            this.$message({
              message: "Please Select Store",
              type: "warning",
            });
            return;
          }
          this.VerificationSecuritiesPh();
        } else if (this.title == "Check") {
          this.StockCodeInquiryPh();
        }
      },

      // phone 点击手动输入
      PhoneManInput() {
        var num = Math.ceil(Math.random() * 100000000).toString();
        var time = new Date().getTime().toString();
        this.user_tag = num + time;
        this.stopScan();
        this.phoneEnter = true;
      },

      // 手动输入点击确认/取消
      clickEnter(name) {
        if (name == "Confirm") {
          this.decodedString = this.phoneManInputEnter;
          this.phoneEnter = false;
          this.phoneContent = true;
          this.phoneLoading = true;
          this.phoneFetchData();
          if (this.title == "Redeem") {
            console.log(this.decodedString);
            var snType = this.decodedString.substr(0, 6);
            if (snType != 'NEGIFT' && (this.storeId == 0 || this.storeId == '')) {
              this.phoneLoading = false;
              this.phoneContent = false;
              this.phoneEnter = true;
              this.$message({
                message: "Please Select Store",
                type: "warning",
              });
              return;
            }
            this.VerificationSecuritiesPh();
            this.phoneManInputEnter = "";
          } else if (this.title == "Check") {
            this.StockCodeInquiryPh();
            this.phoneManInputEnter = "";
          }
        } else if (name == "Cancel") {
          this.phoneEnter = false;
        }
      },

      // 用户中心
      clickDropDown() {
        console.log("用户中心");
        this.arrow = !this.arrow;
        this.userCenter = !this.userCenter;
      },

      // pc 退出登录
      clickLogoutPc() {
        this.clickPcEnter = true;
      },

      // phone 退出登录
      clickLogoutPhone(name) {
        if (name == "Confirm") {
          local.clear();
          this.phoneLogOut = false;
          this.$router.push("/login");
        } else if (name == "Cancel") {
          this.phoneLogOut = false;
        }
      },

      clickLogoutPh() {
        this.phoneLogOut = true;
      },
      // pc 点击退出登录
      clickLogoutPcOut(name) {
        if (name == "Confirm") {
          local.clear();
          this.clickPcEnter = false;
          this.$router.push("/login");
        } else if (name == "Cancel") {
          this.clickPcEnter = false;
        }
      },

      //  pc点击扫码
      async clickScanCode(name) {
        this.pcScanIndex = false;
        this.pcPopup = true;
        this.pxScanCode = true;
        var num = Math.ceil(Math.random() * 100000000).toString();
        var time = new Date().getTime().toString();
        this.user_tag = num + time;

        if (name == "Redeem") {
          // console.log("扫码");
          this.title = "Redeem";
        } else if (name == "Check") {
          this.title = "Check";
          // let { code, msg, data } = await Query(this.sn, user_tag);
        }
      },

      inputNum() {
        this.pxScanCode = false;
        this.loading = true;
        this.fetchData();

        // this.fetchData();
        if (this.title == "Redeem") {
          console.log(this.sn);
          var snType = this.sn.substr(0, 6);
          if (snType != 'NEGIFT' && (this.storeId == 0 || this.storeId == '')) {
            this.loading = false;
            this.pxScanCode = true;
            this.$message({
              message: "Please Select Store",
              type: "warning",
            });
            return;
          }
          this.VerificationSecurities();
        } else if (this.title == "Check") {
          this.StockCodeInquiry();
        }
      },

      // pc核销
      async VerificationSecurities() {
        
        let {
          code,
          msg,
          data
        } = await UseVoucher({
          sn: this.sn,
          user_tag: this.user_tag,
          store_id: this.storeId,
        });
        if (code == "1") {
          this.successfulTips = msg;
          this.loading = false;
          this.success = true;
        } else if (code == "0" && data.error_code == "WAW_SYSTEM_00003") {
          this.overtimeTips = msg;
          this.loading = false;
          this.overtime = true;
        } else if (code == "0" && data.error_code == "NSA_00003") {
          this.$message({
            message: "Login has expired. Please login again",
            type: "warning",
          });
          this.$router.push("/login");
        } else if (code == "0") {
          this.FailMsg = msg;
          this.loading = false;
          this.fail = true;
        }
        
      },

      // 手机核销
      async VerificationSecuritiesPh() {
        // 2021-09-13 在请求核销之前需要先请求check_redeem_type接口来判断是否为credit类型
        const resp = await CheckRedeemType({
          sn: this.decodedString
        })
        if (resp.code == "0") {
          this.PhFailMsg = resp.msg;
          this.phoneContent = true;
          this.phoneLoading = false;
          this.phoneFail = true;
        } else if (resp.code == "1") {
          const checkData = resp.data;
          const redeemType = checkData.type;
          if (redeemType === 3) {
            //调用键盘
            checkData.storeId = this.storeId
            this.$router.push({ name: 'over', params: checkData })
            return;
          }
        }
        let {
          code,
          msg,
          data
        } = await UseVoucher({
          sn: this.decodedString,
          user_tag: this.user_tag,
          store_id: this.storeId,
        });
        if (code == "1") {
          this.successfulTips = msg;
          this.phoneLoading = false;
          this.phoneSuccess = true;
        } else if (code == "0" && data.error_code == "WAW_SYSTEM_00003") {
          this.overtimeTips = msg;
          this.phoneLoading = false;
          this.phoneContent = true;
          this.phoneOvertime = true;
        } else if (code == "0" && data.error_code == "NSA_00003") {
          this.$message({
            message: "Login has expired. Please login again",
            type: "warning",
          });
          this.$router.push("/login");
        } else if (code == "0") {
          this.PhFailMsg = msg;
          this.phoneContent = true;
          this.phoneLoading = false;
          this.phoneFail = true;
        }
        
      },

      // 手机查询
      async StockCodeInquiryPh() {
        let {
          code,
          msg,
          data
        } = await Query({
          sn: this.decodedString,
          user_tag: this.user_tag,
        });
        console.log(data.error_code);
        if (code == "1") {
          this.successfulTips = msg;
          this.phoneLoading = false;
          this.phoneSuccess = true;
        } else if (code == "0" && data.error_code == "4201") {
          this.PhFailMsg = msg;
          this.phoneLoading = false;
          this.phoneContent = true;
          this.phoneFail = true;
          console.log(this.phoneFail);
        } else if (code == "0" && data.error_code == "WAW_SYSTEM_00003") {
          this.overtimeTips = msg;
          this.phoneContent = true;
          this.phoneLoading = false;
          this.phoneLoading = false;
          this.phoneOvertime = true;
        } else if (code == "0" && data.error_code == "NSA_00003") {
          this.$message({
            message: "Login has expired. Please login again",
            type: "warning",
          });
          this.$router.push("/login");
        } else if (code == "0") {
          this.phoneContent = true;
          this.PhFailMsg = msg;
          this.phoneLoading = false;
          this.phoneFail = true;
        }
      },

      // pc查询
      async StockCodeInquiry() {
        let {
          code,
          msg,
          data
        } = await Query({
          sn: this.sn,
          user_tag: this.user_tag,
        });
        if (code == "1") {
          this.successfulTips = msg;
          this.loading = false;
          this.success = true;
        } else if (code == "0" && data.error_code == "WAW_SYSTEM_00003") {
          this.overtimeTips = msg;
          this.loading = false;
          this.overtime = true;
        } else if (code == "0" && data.error_code == "NSA_00003") {
          this.$message({
            message: "Login has expired. Please login again",
            type: "warning",
          });
          this.$router.push("/login");
        } else if (code == "0") {
          this.FailMsg = msg;
          this.loading = false;
          this.fail = true;
        }
      },

      // 手动输入劵码提交
      MannulInputSubmit() {
        if (!(this.sn = "")) {
          this.$message({
            message: "Please input the security code",
            type: "warning",
          });
          return false;
        }

        this.pxScanCode = false;
        this.loading = true;
        this.fetchData();

        if (this.title == "Redeem") {

          console.log(this.sn);
          var snType = this.sn.substr(0, 6);
          if (snType != 'NEGIFT' && (this.storeId == 0 || this.storeId == '')) {
            this.loading = false;
            this.pxScanCode = true;
            this.$message({
              message: "Please Select Store",
              type: "warning",
            });
            return;
          }

          this.VerificationSecurities();
        } else if (this.title == "Check") {
          this.StockCodeInquiry();
        }
      },

      // 关闭弹窗
      clickClose(name) {
        if (name == "loading") {
          this.pcPopup = false;
          this.loading = false;
          this.pcScanIndex = true;
          this.sn = "";
        } else if (name == "overtime") {
          this.pcPopup = false;
          this.overtime = false;
          this.pcScanIndex = true;
          this.sn = "";
        } else if (name == "success") {
          this.pcPopup = false;
          this.success = false;
          this.pcScanIndex = true;
          this.sn = "";
        } else if (name == "fail") {
          this.pcPopup = false;
          this.fail = false;
          this.pcScanIndex = true;
          this.sn = "";
        }
      },

      // 跳转到history
      clickGoHistory() {
        this.$router.push("/history");
      },

      // 关闭手机弹窗
      clickClosephoneFail() {
        this.phoneFail = false;
        this.phoneSuccess = false;
        this.phoneOvertime = false;
        this.phoneLoading = false;
        this.phoneContent = false;
      },

      // loading倒计时
      fetchData() {
        let _that = this;
        let timeId = setInterval(function () {
          --_that.countDown;
          if (!_that.loading) {
            clearInterval(timeId);
            _that.countDown = 30;
          }
          if (_that.countDown <= 0) {
            clearInterval(timeId);
            _that.pcPopup = false;
            _that.loading = false;
            _that.pcScanIndex = true;
            _that.countDown = 30;
          }
        }, 1000);
      },

      phoneFetchData() {
        let _that = this;
        let phTimeId = setInterval(function () {
          --_that.phonecountDown;
          if (!_that.phoneLoading) {
            clearInterval(phTimeId);
            _that.phonecountDown = 30;
          }
          if (_that.phonecountDown <= 0) {
            clearInterval(phTimeId);
            _that.phoneContent = false;
            _that.phoneLoading = false;
            _that.phonecountDown = 30;
          }
        }, 1000);
      },

      // 超时点击重试
      clickRetry(name) {
        if (name == "phone") {
          this.phoneOvertime = false;
          this.phoneLoading = true;
          this.StockCodeInquiryPh();
        } else if (name == "pc") {
          this.overtime = false;
          this.loading = true;
          this.StockCodeInquiry();
        }
      },

      loactionHerf() {
        location.href =
          "https://web.npn.sg/retailer/index.php/Retail/index?token=" +
          local.get("t_k");
      },

      clickClosePcScan() {
        this.pcScanIndex = true;
        this.pcPopup = false;
        this.loading = false;
      },
    },
    mounted() {
      this.$refs.photo.$el.style.opacity = 0; //为了隐藏file input
      this.isSupportTorch = true;
      this.getOptions();
      document.addEventListener('click', function (e) {
        if (e.target.id != 'show_text' && e.target.id != 'down_icon') {
          $("#_option").hide();
        }
      });

      // $(document).mouseup(function (e) {
      //   var _con = $("#pc-content");
      //   if (!_con.is(e.target) && _con.has(e.target).length === 0) {
      //     console.log(111);
      //     e.preventDefault();
      //     return false;
      //   }
      // });
    },

    created() {},
    computed: {

      isUrl() {
        return isURL(this.decodedString);
      },
      /*options:async function () {
          let { code, msg, data } = await getStoreIds();

          if (code == "1") {
              console.log(data.list);
              return data.list;
          }else{
              return [];
          }
      }*/
    },
  };
</script>

<style lang="less" scoped>
  .here {
    text-decoration: underline;
  }

  @font-face {
    font-family: "title";
    src: url("../assets/font/CENSCBK.TTF");
  }


  @font-face {
    font-family: "Poppins-Regular";
    src: url("../assets/font/Poppins-Regular.ttf");
  }

  @font-face {
    font-family: "Poppins-SemiBold";
    src: url("../assets/font/Poppins-SemiBold.ttf");
  }

  /deep/.el-message__content {
    font-family: "Poppins-Regular";
  }

  .el-input__inner2 {
    background-color: black !important;
    color: #fff !important;
  }

  // @media screen and (max-width: 750px){
  //   html{
  //     font-size: 12px;
  //   }
  // }
  // @media screen and (min-width: 375px){
  //   html{
  //     font-size: 12px;
  //   }
  // }
  @media screen and (max-height:700px) {
    ._option {
      max-height: 120px !important;
    }

    .giftLogo {
      margin-top: 38% !important;
    }
  }

  // @media screen and (max-width: 992px) {

  .pc-enter {
    display: none;
  }

  .index {
    margin: auto;
    max-width: 450px;
    max-height: 750px;
    width: 100%;
    height: 100%;
    display: flex;
    position: relative;
    flex-direction: column;
    background: url(../assets/img/pic/phone/phone-bj.png) no-repeat;
    background-size: 100% 100%;

    .main {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, 0.5);
      flex: 1;

      .storeid {
        width: 100%;
        text-align: center;
        margin-top: 10px;

        .div_sel {
          width: 85%;
          margin: auto;
          text-align: center;
          font-family: Poppins-Regular;
          border-radius: 2.5px;
          border: solid 1px #f3f4f5;
          color: #fff;
          line-height: 40px;
          overflow: hidden;
          // margin-left: calc(50% - 150px);
          background: rgba(33, 31, 30, .45);
          display: flex;
          justify-content: space-between;
        }

        .options {
          min-height: 40px;
          line-height: 40px;
          // padding: 3px;
          overflow: hidden;
          background-color: transparent;
          color: #fff;
          word-break: break-word;
          padding-left: 24px;
          text-align: left;
          font-family: Poppins-Regular;
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 1px;
        }

        .options:hover {
          background-color: rgba(255, 255, 255, .4);
          color: #fff;
        }

        ._option {
          list-style: none;
          border-radius: 2.5px;
          background: rgba(33, 31, 30, .45);
          border: solid 1px #ffffff;
          display: none;
          position: fixed;
          max-height: 160px;
          overflow: auto;
        }

        .store_id_div {
          color: #fff;
          height: 40px;
          font-size: 14px;
          line-height: 40px;
          width: calc(100% - 115px);
          margin-left: 58px;
        }
      }

      .account {
        position: absolute;
        right: 20px;
        top: 20px;
        color: #fff;

        .user {
          margin-bottom: 15px;
          text-align: right;

          &>img {
            width: 18px;
          }

          .jiantou {
            width: 7px;
            margin-left: 7px;
          }

          .jiantou1 {
            width: 12px;
            margin-left: 7px;
          }
        }

        .logout {
          .Logout-pc {
            display: none;
          }

          &>p {
            margin-bottom: 12px;
            color: #fff;
            font-size: 13px;
            font-family: Poppins-Regular;

            &>a {
              color: #fff;
              font-size: 13px;
              text-decoration: none;
            }

            &>img {
              width: 16px;
              margin-right: 6px;
            }
          }
        }
      }

      .giftLogo {
        margin: auto;
        display: block;
        width: 99px;
        height: 69px;
        margin-top: 50%;
        margin-bottom: 8%;
      }

      .pc-content {
        display: none;
      }

      .bottom {
        position: absolute;
        bottom: 0;
        width: 100%;
        color: #fff;
        display: flex;
        flex-direction: column;

        .modular {
          display: flex;
          justify-content: space-around;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translate(-50%, -16px);

          .modular-left {
            display: none;
            color: #fff;
          }

          .modular-right {
            text-align: center;

            &>div {
              margin: 0 auto;
              background: #fff;
              width: 60px;
              height: 60px;
              border-radius: 50%;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-bottom: 20px;
            }

            &>p {
              font-size: 18px;
            }
          }
        }

        .function {
          font-size: 18px;
          display: flex;
          justify-content: space-around;
          align-items: flex-end;
          height: 80px;
          background: rgba(33, 31, 30, .35);


          .history {
            display: flex;
            flex-direction: column;
            align-items: center;

            &>img {
              width: 36px;
              height: 36px;
              margin-bottom: 8px;
            }
          }

          .check {
            display: flex;
            flex-direction: column;
            align-items: center;

            &>img {
              width: 36px;
              height: 36px;
              margin-bottom: 8px;
            }
          }
        }
      }

      .phone-content {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .phone-public {
          text-align: center;

          .phone-loading {
            &>img {
              width: 62px;
              animation: rotate 2.5s linear infinite;

              @keyframes rotate {
                0% {
                  transform: rotateZ(0deg);
                  /*从0度开始*/
                }

                100% {
                  transform: rotateZ(360deg);
                  /*360度结束*/
                }
              }
            }

            &>p {
              color: #fff;
              font-size: 20px;
              margin: 30px 0;
            }
          }

          .phone-overtime {
            text-align: center;
            color: #fff;

            &>img {
              width: 120px;
            }

            .ph-p1 {
              width: 70%;
              margin: 0 auto;
              margin-top: 20px;
              line-height: 25px;
            }

            .ph-p2 {
              margin: 20px 0;
            }
          }

          .phone-success {
            text-align: center;

            &>img {
              width: 62px;
            }

            &>p {
              font-family: Poppins-SemiBold;
              text-align: center;
              margin: auto;
              width: 80%;
              color: #fff;
              font-size: 16px;
              margin-top: 20px;
              word-break: normal;
              // word-wrap: break-word;
              line-height: 24px;
              min-width: 100px;
            }
          }

          .phone-fail {
            text-align: center;

            &>img {
              width: 62px;
            }

            &>p {
              font-family: Poppins-SemiBold;

              text-align: center;
              margin: auto;
              // width: 80%;
              color: #fff;
              font-size: 16px;
              margin-top: 20px;
              word-break: normal;
              word-wrap: break-word;
              line-height: 24px;
            }

            .phone-fail-p1 {
              margin-top: 20px;
            }

            .phone-fail-p2 {
              margin-bottom: 20px;
            }
          }
        }

        .phone-close {
          width: 35px;
          margin-top: 20px;
        }
      }

      .please-enter {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .enter-content {
          text-align: center;
          width: 70%;

          .enter-img {
            width: 120px;
            margin: 0 auto;

            &>img {
              width: 100%;
            }
          }

          .ph-enter-img {
            width: 100px;
          }

          .enter-input {
            width: 100%;
            height: 50px;
            background: rgba(0, 0, 0, 0.6);
            outline: none;
            border-radius: 5px;
            border: 1px solid rgba(255, 255, 255, 0.3);
            margin: 40px 0;
            color: #fff;
            text-indent: 5px;
            font-size: 18px;
            font-family: Poppins-Regular;

            &::placeholder {
              color: #5b5b5b;
              font-size: 0.94rem;
              // text-align: center;
            }
          }

          .enter-box {
            display: flex;
            justify-content: space-around;

            .enter-confirm {
              width: 80px;
              height: 40px;
              background-color: #1cce72;
              line-height: 40px;
              border-radius: 5px;
              border: none;
              color: #fff;
              outline: none;
              font-size: 14px;
            }

            .enter-cancel {
              width: 80px;
              height: 40px;
              border: 1px solid #fff;
              line-height: 40px;

              background: #000;
              border-radius: 5px;
              color: #fff;
              outline: none;
              font-size: 14px;
              margin-left: -50px;
            }
          }

          .enter-LoOut {
            color: #fff;
            margin: 40px 0;
          }
        }
      }
    }

    .Mannul {
      width: 80%;
      height: 50px;
      background: rgba(0, 0, 0, 0.6);
      color: #fff;
      border-radius: 5px;
      font-size: 18px;
      border: none;
    }

    .scanWrapper {
      width: 100%;
      height: 100%;
    }

    .scanWrapper .overlay {
      display: flex;
      align-items: center;
    }

    .loading-indicator {
      text-align: center;
      flex: 1;
    }

    .spinner {
      width: 70px;
      height: 70px;
      background: #eee;
      border-radius: 50%;
      position: relative;
      margin: 40px;
      display: inline-block;
    }

    .spinner:after,
    .spinner:before {
      content: "";
      display: block;
      width: 70px;
      height: 70px;
      border-radius: 50%;
    }

    .spinner__1::after {
      position: absolute;
      border: 4px solid transparent;
      border-top-color: #2ecc71;
      border-bottom-color: #2ecc71;
      top: -4px;
      left: -4px;
      animation: spin 2s linear infinite;
    }

    .spinner__1::before {
      position: absolute;
      top: 17px;
      left: 17px;
      height: 35px;
      width: 35px;
      background-color: #1abc9c;
      animation: shrink 3s ease infinite;
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg) scale(1);
      }

      50% {
        transform: rotate(180deg) scale(1.4);
      }

      100% {
        transform: rotate(360deg) scale(1);
      }
    }

    @keyframes shrink {
      0% {
        transform: scale(1);
      }

      50% {
        transform: scale(1.6);
      }

      100% {
        transform: scale(1);
      }
    }

    .header {
      display: flex;
      position: absolute;
      top: 2vh;
      left: 1vh;
      color: #fff;
      width: 100%;
    }

    .header i {
      font-size: 25px;
    }

    .header .title {
      flex: 1;
      text-align: center;
      padding-right: 16px;
      font-size: 20px;
    }

    .scanBox {
      width: 80%;
      height: 60%;
      top: 15%;
      left: 10%;
      position: absolute;

      .scanBox-btn {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 100px;
        height: 30px;
        color: #fff;
        background: #ff9900;
        outline: none;
        border: none;
        border-radius: 5px;
      }
    }

    @-webkit-keyframes scanner {
      0% {
        bottom: 100%;
      }

      50% {
        bottom: 0%;
      }

      100% {
        bottom: 100%;
      }
    }

    @-moz-keyframes scanner {
      0% {
        bottom: 100%;
      }

      50% {
        bottom: 0%;
      }

      100% {
        bottom: 100%;
      }
    }

    @-o-keyframes scanner {
      0% {
        bottom: 100%;
      }

      50% {
        bottom: 0%;
      }

      100% {
        bottom: 100%;
      }
    }

    @keyframes scanner {
      0% {
        bottom: 100%;
      }

      50% {
        bottom: 0%;
      }

      100% {
        bottom: 100%;
      }
    }

    .lineScanner {
      width: 100%;
      height: 2px;
      background: #4caf50;
      position: absolute;
      -webkit-transition: all 200ms linear;
      -moz-transition: all 200ms linear;
      transition: all 200ms linear;
      -webkit-animation: scanner 3s infinite linear;
      -moz-animation: scanner 3s infinite linear;
      -o-animation: scanner 3s infinite linear;
      animation: scanner 3s infinite linear;
      box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.4);
      display: none;
    }

    .footer {
      position: absolute;
      bottom: 8vh;
      width: 100%;
      height: 50px;
      text-align: center;
      display: flex;
      justify-content: space-around;
    }

    .footer i {
      font-size: 40px;
      color: #fff;
    }

    .torch-disabled {
      color: grey !important;
    }

    .mint-toast {
      z-index: 2005;
    }
  }

  // }
</style>